import { FallbackRender } from "@sentry/react"

export const ErrorFallback: FallbackRender = (errorData) => {
	const { error, resetError } = errorData
	resetError()
	return <i>error: {error.message}</i>
}
